module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-181.0d144844.svg";